import { getVesselAlarms } from "@/services/data_overview/alarms";
import { getDataOverviewList } from "@/services/data_overview/data_overview";
import {
  alarmsMapper,
  dataOverviewListMapper,
} from "@/domain/data_overview/mapper";
import {
  EMPTY_ALARMS,
  EMPTY_DATA_OVERVIEW_LIST,
} from "@/domain/data_overview/data";

const EMPTY_ALARM_LIST = [];

const state = {
  dataOverviewList: EMPTY_DATA_OVERVIEW_LIST,
  alarmList: EMPTY_ALARM_LIST,
  vesselAlarms: EMPTY_ALARMS,
};

const mutations = {
  SET_DATA_OVERVIEW_LIST(state, payload) {
    state.dataOverviewList = payload;
  },

  SET_ALARM_LIST(state, payload) {
    state.alarmList = payload;
  },

  SET_VESSEL_ALARMS(state, payload) {
    state.vesselAlarms = payload;
  },
};

const getters = {
  getDataOverviewList: (state) => state.dataOverviewList,
  getAlarmList: (state) => state.alarmList,
  getVesselAlarms: (state) => state.vesselAlarms,
};

const actions = {
  async fetchDataOverviewList({ commit }) {
    try {
      const response = await getDataOverviewList();
      commit("SET_DATA_OVERVIEW_LIST", dataOverviewListMapper(response));
    } catch (error) {
      commit("SET_DATA_OVERVIEW_LIST", EMPTY_DATA_OVERVIEW_LIST);
    }
  },

  // Alarm column names for one vessel, e.g. ["Fire_Alarm", "Bwts_Alarm", ...]
  async fetchAlarmList({ commit }, vesselName) {
    commit("SET_ALARM_LIST", EMPTY_ALARM_LIST);
    if (!vesselName) return;

    try {
      const response = await getVesselAlarms(vesselName);
      const columns =
        response && response.success && Array.isArray(response.data)
          ? response.data
          : EMPTY_ALARM_LIST;
      commit("SET_ALARM_LIST", columns);
    } catch (error) {
      console.error("[fetchAlarmList] failed:", error);
      commit("SET_ALARM_LIST", EMPTY_ALARM_LIST);
    }
  },

  async fetchVesselAlarms({ commit }, vesselName) {
    try {
      const response = await getVesselAlarms(vesselName);
      commit("SET_VESSEL_ALARMS", alarmsMapper(response));
    } catch (error) {
      commit("SET_VESSEL_ALARMS", EMPTY_ALARMS);
    }
  },
};

export default {
  namespaced: false,
  state,
  mutations,
  getters,
  actions,
};
